import { render, staticRenderFns } from "./Writequestion.vue?vue&type=template&id=695f093a&scoped=true"
import script from "./Writequestion.vue?vue&type=script&lang=js"
export * from "./Writequestion.vue?vue&type=script&lang=js"
import style0 from "./Writequestion.vue?vue&type=style&index=0&id=695f093a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f093a",
  null
  
)

export default component.exports